import {SOPostProject} from '../../core/project/so-post-project';
import {ProjectCore} from './project.core';
import {SOGetProject} from '../../core/project/so-get-project';
import {FormField, SelectionOption} from 'lionheartland';
import {postProjectFormFieldOptions} from './post-project-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {OrganizationCore} from '../organization/organization.core';
import {SOGetOrganization} from '../../core/organization/so-get-organization';

export class RAPostProject extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postProjectFormFieldOptions);

  RequestClass = SOPostProject

  constructor(
    public entityCore: ProjectCore
  ) {
    super();
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier('name'),
      this.getFormValueFromIdentifier(
        'organization',
        SOGetOrganization,
        true,
      ),
      this.getFormValueFromIdentifier('description'),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}